import {Action} from "redux";

import {
    GetCustomerBlackListRequest,
    AddCustomerBlackListRequest,
    DeleteCustomerBlackListRequest
} from "../request/customer_black_request";
import {
    GetCustomerBlackListResponse,
    AddCustomerBlackListResponse,
    DeleteCustomerBlackListResponse,
} from "../response/customer_black_list_response";

export enum CustomerBlackListActionType {

    REQUEST_GET_CUSTOMER_BLACK_LIST = "CUSTOMER_BLACK_LIST_REQUEST_GET_CUSTOMER_BLACK_LIST",
    CALLBACK_GET_CUSTOMER_BLACK_LIST = "CUSTOMER_BLACK_LIST_CALLBACK_GET_CUSTOMER_BLACK_LIST",

    REQUEST_ADD_CUSTOMER_BLACK_LIST = "CUSTOMER_BLACK_LIST_REQUEST_ADD_CUSTOMER_BLACK_LIST",
    CALLBACK_ADD_CUSTOMER_BLACK_LIST = "CUSTOMER_BLACK_LIST_CALLBACK_ADD_CUSTOMER_BLACK_LIST",

    REQUEST_DELETE_CUSTOMER_BLACK_LIST = "CUSTOMER_BLACK_LIST_REQUEST_DELETE_CUSTOMER_BLACK_LIST",
    CALLBACK_DELETE_CUSTOMER_BLACK_LIST = "CUSTOMER_BLACK_LIST_CALLBACK_DELETE_CUSTOMER_BLACK_LIST",
}

export interface IRequestGetCustomerBlackListAction extends Action {
    type: CustomerBlackListActionType.REQUEST_GET_CUSTOMER_BLACK_LIST;
    item: GetCustomerBlackListRequest;
}
export interface ICallbackGetCustomerBlackListAction extends Action {
    type: CustomerBlackListActionType.CALLBACK_GET_CUSTOMER_BLACK_LIST;
    isSuccess: boolean;
    item?: GetCustomerBlackListResponse;
}

export interface IRequestAddCustomerBlackListAction extends Action {
    type: CustomerBlackListActionType.REQUEST_ADD_CUSTOMER_BLACK_LIST;
    item: AddCustomerBlackListRequest;
}
export interface ICallbackAddCustomerBlackListAction extends Action {
    type: CustomerBlackListActionType.CALLBACK_ADD_CUSTOMER_BLACK_LIST;
    isSuccess: boolean;
    item?: AddCustomerBlackListResponse;
}

export interface IRequestDeleteCustomerBlackListAction extends Action {
    type: CustomerBlackListActionType.REQUEST_DELETE_CUSTOMER_BLACK_LIST;
    item: DeleteCustomerBlackListRequest;
}
export interface ICallbackDeleteCustomerBlackListAction extends Action {
    type: CustomerBlackListActionType.CALLBACK_DELETE_CUSTOMER_BLACK_LIST;
    isSuccess: boolean;
    item?: DeleteCustomerBlackListResponse;
}

export type CustomerBlackListAction =
    IRequestGetCustomerBlackListAction |
    ICallbackGetCustomerBlackListAction |
    IRequestAddCustomerBlackListAction |
    ICallbackAddCustomerBlackListAction |
    IRequestDeleteCustomerBlackListAction |
    ICallbackDeleteCustomerBlackListAction
    ;

export interface ICustomerBlackListActionCreator {

    requestGetCustomerBlackListAction(
        item: GetCustomerBlackListRequest
    ): IRequestGetCustomerBlackListAction;
    callbackGetCustomerBlackListAction(
        isSuccess: boolean,
        item?: GetCustomerBlackListResponse,
    ): ICallbackGetCustomerBlackListAction;

    requestAddCustomerBlackListAction(
        item: AddCustomerBlackListRequest
    ): IRequestAddCustomerBlackListAction;
    callbackAddCustomerBlackListAction(
        isSuccess: boolean,
        item?: AddCustomerBlackListResponse,
    ): ICallbackAddCustomerBlackListAction;

    requestDeleteCustomerBlackListAction(
        item: DeleteCustomerBlackListRequest
    ): IRequestDeleteCustomerBlackListAction;
    callbackDeleteCustomerBlackListAction(
        isSuccess: boolean,
        item?: DeleteCustomerBlackListResponse,
    ): ICallbackDeleteCustomerBlackListAction;
}

class ActionCreator implements ICustomerBlackListActionCreator {

    public requestGetCustomerBlackListAction = (
        item: GetCustomerBlackListRequest
    ): IRequestGetCustomerBlackListAction => {
        return {
            type: CustomerBlackListActionType.REQUEST_GET_CUSTOMER_BLACK_LIST,
            item,
        };
    };
    public callbackGetCustomerBlackListAction = (
        isSuccess: boolean,
        item?: GetCustomerBlackListResponse,
    ): ICallbackGetCustomerBlackListAction => {
        return {
            type: CustomerBlackListActionType.CALLBACK_GET_CUSTOMER_BLACK_LIST,
            isSuccess,
            item,
        };
    };

    public requestAddCustomerBlackListAction = (
        item: AddCustomerBlackListRequest
    ): IRequestAddCustomerBlackListAction => {
        return {
            type: CustomerBlackListActionType.REQUEST_ADD_CUSTOMER_BLACK_LIST,
            item,
        };
    };
    public callbackAddCustomerBlackListAction = (
        isSuccess: boolean,
        item?: AddCustomerBlackListResponse,
    ): ICallbackAddCustomerBlackListAction => {
        return {
            type: CustomerBlackListActionType.CALLBACK_ADD_CUSTOMER_BLACK_LIST,
            isSuccess,
            item,
        };
    };

    public requestDeleteCustomerBlackListAction = (
        item: DeleteCustomerBlackListRequest
    ): IRequestDeleteCustomerBlackListAction => {
        return {
            type: CustomerBlackListActionType.REQUEST_DELETE_CUSTOMER_BLACK_LIST,
            item,
        };
    };
    public callbackDeleteCustomerBlackListAction = (
        isSuccess: boolean,
        item?: DeleteCustomerBlackListResponse,
    ): ICallbackDeleteCustomerBlackListAction => {
        return {
            type: CustomerBlackListActionType.CALLBACK_DELETE_CUSTOMER_BLACK_LIST,
            isSuccess,
            item,
        };
    };

}

export const createCustomerBlackListActionCreator = (): ICustomerBlackListActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/customer_black_list_action.ts